import * as React from 'react';

import type {LeadRecapsHelpPage} from './help-lead-recaps';
import {getGraphic} from './helpers';

import styles from './help-lead-recaps.module.css';

export type Props = {
    page: LeadRecapsHelpPage;
};

export function HelpLeadRecapsGraphic(props: Props) {
    const {page} = props;

    return <div className={styles['base-graphic']}>{getGraphic(page)}</div>;
}
